module.exports = __webpack_public_path__ + "static/media/Screenshot2020-07-3121.25.42-min.ff2ae06d.png";